/** Category may be a populated `{ name, slug }` or legacy string. */
export function getCategoryLabel(category) {
  if (category == null || category === '') return '';
  if (typeof category === 'string') return category;
  if (typeof category === 'object' && category.name) return category.name;
  return '';
}
